import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { manageDeatilsPopup } from '../../features/ControlSlice'
import Deadline from '../Deadline'
import Popup from '../Popup'

const TaskDetails = ({id} : any) => {
    const dispatch = useDispatch()
    const showDetailsPopup = useSelector((state: RootState) => state.controls.showDetailsPopup)
    const task = useSelector((state: RootState) => state.todos.find(item => item.id === id))

    const handleClosePopup = () => {
      dispatch(manageDeatilsPopup(false))
    }

    return (
        <div>
        {
            showDetailsPopup === id &&
            <Popup title="Task details" setClose={handleClosePopup}>
                {
                    task &&
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        height: '100%'
                    }}>
                        <div>
                        <h3>{task.title}</h3>
                        <p style={{marginBottom: 20}}>{task.description}</p>
                        </div>
                        <Deadline deadline={task.deadline}/>
                    </div>
                }
            </Popup>
        }
        </div>
    )
}

export default TaskDetails